import { render, staticRenderFns } from "./DepartmentLineMenu.vue?vue&type=template&id=dcc4ba80&scoped=true"
import script from "./DepartmentLineMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentLineMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DepartmentLineMenu.vue?vue&type=style&index=0&id=dcc4ba80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc4ba80",
  null
  
)

export default component.exports